import { makeStyles } from "@material-ui/core";
export const DetailPageStyles = makeStyles((theme) => ({
  backgroundSection: {
    background: theme.palette.background.default,
  },
  sectionWidth: {
    paddingBottom: "50px",
    minHeight: "0px",
    transform: "translateY(-50px)",
  },
  tabPanelDesktop: { marginTop: "30px" },
  tabPanelMobile: { marginTop: "0px" },
  bgTop: {
    backgroundRepeat: "none",
    backgroundPositionY: "40%",
    backgroundSize: "cover",
    paddingTop: "450px",
    filter: "blur(15px)",
  },
  tabNormal: {
    backgroundColor: "transparent",
    textTransform: "capitalize",
    border: "none",
    transition: "all .2s",
    lineHeight: "24px",
    height: "24px",
    fontSize: "14px",
    "&:hover": {
      fontSize: "18px",
    },
  },
  tabActive: {
    backgroundColor: "transparent",
    textTransform: "capitalize",
    border: "none",
    transition: "all .2s",
    lineHeight: "24px",
    height: "24px",
    fontSize: "18px",
  },
  detailMainInfo: {
    position: "absolute",
    top: "50%",
    width: "100%",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
  mainMaxWidth: {
    maxWidth: "870px",
    margin: "auto",
    padding: "0px 15px",
  },
  mainMaxWidthMobile: {
    margin: "auto",
    padding: 0,
    overflowX: "hidden",
  },
  posterMain: {
    borderRadius: "4px",
    paddingTop: "147.90697674%",
    backgroundPosition: "center,0 0",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat,repeat-y",
    position: "relative",
    "& img": {
      transition: "all .2s",
      top: "50%",
      left: "50%",
      position: "absolute",
      transform: "translate(-50%, -50%)",
      cursor: "pointer",
      visibility: "hidden",
    },
    "&:hover": {
      "& img": {
        visibility: "visible",
      },
    },
  },
  mainHeightTop: {
    position: "relative",
    maxHeight: "450px",
    overflow: "hidden",
  },
  styleGradient: {
    top: 0,
    left: 0,
    position: "absolute",
    width: "100%",
    height: "100%",
    background: `linear-gradient(to top,${theme.palette.background.default} , transparent 100%)`,
  },
  detailMainInfo1: {
    fontSize: "14px",
    color: theme.palette.primary,
  },
  detailMainInfo2: {
    fontSize: "24px",
    color: theme.palette.primary,
    marginBottom: 0,
    whiteSpace: "nowrap",
    "& span": {
      marginRight: "6px",
      marginTop: "6px",
      float: "left",
      backgroundColor: "#fb4226",
      color: "#fff",
      fontSize: "16px",
      borderRadius: "4px",
      padding: "0 5px",
      display: "inline-block",
      textAlign: "center",
      minWidth: "33px",
    },
  },
  btnBuyTicketDetail: {
    fontSize: "16px",
    borderRadius: "4px",
    textAlign: "center",
    background: "0 0",
    padding: "7px 25px",
    transition: "all .2s",
    marginTop: "25px",
    marginBottom: "20px",
    backgroundColor: " #fb4226",
    border: "none",
    color: "#fff",
    maxWidth: "130px",
  },
  scoreReview: {
    fontSize: "2rem",
    color: "#fff",
  },
  ratingStar: {
    marginTop: "10px",
    fontSize: "25px",
  },
  newDesign: {
    maxWidth: "580px",
    marginLeft: "calc(50% - 290px)",
    marginRight: "calc(50% - 290px)",
  },
  dadInputReviewer: {
    position: "relative",
    cursor: "pointer",
  },
  inputReviewer: {
    appearance: "none",
    padding: "10px 10px 10px 55px",
    width: "100%",
    height: "60px",
    borderRadius: "4px",
    border: "1px solid #e8e8e9",
    background: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontSize: "14px",
    cursor: "pointer",
  },
  reviewStar: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    right: "3%",
    opacity: 0.5,
    fontSize: "30px",
  },
  accountIcon: {
    position: "absolute",
    color: theme.palette.text.primary,
    top: "50%",
    left: "2%",
    opacity: 0.5,
    fontSize: "40px",
    transform: "translateY(-50%)",
  },
  cardRoot: {
    marginBottom: "15px",
  },
  cardMedia: {
    height: 0,
    paddingTop: "150%",
    width: "100%",
  },
  cardActionArea: {
    position: "relative",
    "&:focus": {
      outline: "none",
    },
  },
  cardOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "linear-gradient(to top, black, transparent)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  indicatorTop: {
    display: "none",
  },
  horizontalScroll: {
    height: "90px!important",
  },
  bgAccor: {
    background: "transparent",
    borderBottom: "1px solid rgba(255, 255, 255, 0.54)",
  },
  avatar: {
    fontSize: theme.typography.pxToRem(15),
    flexShrink: 0,
    marginRight: "15px",
  },
  expandIcon: {
    color: "rgba(255, 255, 255, 0.54)",
    transform: "rotate(0deg)",
  },
  nameCinemaSystem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.primary,
    textTransform: "capitalize",
  },
}));

export const ReviewTabStyles = makeStyles((theme) => ({
  tabPanelDesktop: { marginTop: "30px" },
  tabPanelMobile: { marginTop: "0px" },
  newDesign: {
    maxWidth: "580px",
    marginLeft: "calc(50% - 290px)",
    marginRight: "calc(50% - 290px)",
  },
  dadInputReviewer: {
    position: "relative",
    cursor: "pointer",
  },
  inputReviewer: {
    appearance: "none",
    padding: "10px 10px 10px 55px",
    width: "100%",
    height: "60px",
    borderRadius: "4px",
    border: "1px solid #e8e8e9",
    background: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontSize: "14px",
    cursor: "pointer",
  },
  reviewStar: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    right: "3%",
    opacity: 0.5,
    fontSize: "30px",
  },
  accountIcon: {
    position: "absolute",
    color: theme.palette.text.primary,
    top: "50%",
    left: "2%",
    opacity: 0.5,
    fontSize: "40px",
    transform: "translateY(-50%)",
  },
  dialog: {
    height: "auto!important",
  },
  dialogContent: {
    background: "#fff",
    padding: "15px",
  },
  ratingDialog: {},
  score: {
    fontSize: "40px",
    color: "#7ed321",
    fontFamily: "SF Medium",
    textAlign: "center",
    marginTop: "-20px",
    marginBottom: "-5px",
    fontWeight: "bold",
  },
  inputComment: {
    margin: "20px",
    width: "90%",
    background: "#fff",
    resize: "none",
    fontSize: "16px",
    appearance: "none",
    padding: "20px",
    borderRadius: "4px",
    border: "1px solid #e8e8e9",
    transition: "all .2s",
    "&:focus": {
      outlineWidth: 0,
      borderColor: "#fb4226!important",
      boxShadow: "inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(251,66,38,.6)",
    },
  },
}));
